// extracted by css-extract-rspack-plugin
export default {"form":"C7QtmMXxosIueDrn__form___","filterSection":"yrstrCmGJMT6x00L__filterSection___"};